export const OFTEN_SCREEN_IDS = {
  ORDER_REGISTER: 1, // 新規発注
  ORDER_HISTORY: 2, // 発注履歴
  ORDER_LOADING: 3, // 入庫履歴
  SALES_REGISTER: 4, // 新規販売
  SALES_HISTORY: 5, // 販売履歴
  SALES_SHIP: 6, // 出庫履歴
  STORAGE_REGISTER: 7, // 在庫移動
  STORAGE_HISTORY: 8, // 在庫移動履歴
  STORAGE_ADJUST_REGISTER: 9, // 在庫調整
  STORAGE_ADJUST_HISTORY: 10, // 在庫調整履歴
  STORAGE_PRODUCT_STOCKS: 11, // 在庫一覧
  MASTER_PRODUCT: 12, // 商品
  MASTER_SUPPLIER: 13, // 仕入先
  MASTER_CUSTOMER: 14, // 顧客
  MASTER_STORAGE: 15, // 倉庫
  CSV_UPLOAD: 16, // CSVアップロード
  CSV_HISTORY: 17, // CSV履歴
  CSV_JD_PRODUCT: 18, // JD商品マスタ
  LEDGER_SHEET: 19 // 帳票
}

export const OFTEN_SCREEN_INFO = {
  [OFTEN_SCREEN_IDS.ORDER_REGISTER]: {
    name: 'common.input_new-order',
    link: 'order.register'
  },
  [OFTEN_SCREEN_IDS.ORDER_HISTORY]: {
    name: 'common.common_loading-order-history',
    link: 'order.history'
  },
  [OFTEN_SCREEN_IDS.ORDER_LOADING]: {
    name: 'loading.loading_receipt-history',
    link: 'order.loading'
  },
  [OFTEN_SCREEN_IDS.SALES_REGISTER]: {
    name: 'sale.sale_new-sale',
    link: 'sales.register'
  },
  [OFTEN_SCREEN_IDS.SALES_HISTORY]: {
    name: 'common.common_ship-sale-history',
    link: 'sales.history'
  },
  [OFTEN_SCREEN_IDS.SALES_SHIP]: {
    name: 'common.common_ship-history',
    link: 'sales.ship'
  },
  [OFTEN_SCREEN_IDS.STORAGE_REGISTER]: {
    name: 'common.common_storage-move',
    link: 'storage.register'
  },
  [OFTEN_SCREEN_IDS.STORAGE_HISTORY]: {
    name: 'storage.storage_storage-move-history',
    link: 'storage.history'
  },
  [OFTEN_SCREEN_IDS.STORAGE_ADJUST_REGISTER]: {
    name: 'common.common_stock-adjust',
    link: 'storage.adjust.register'
  },
  [OFTEN_SCREEN_IDS.STORAGE_ADJUST_HISTORY]: {
    name: 'common.common_stock-adjust-history',
    link: 'storage.adjust.history'
  },
  [OFTEN_SCREEN_IDS.STORAGE_PRODUCT_STOCKS]: {
    name: 'common.common_stock-list',
    link: 'storage.productStocks'
  },
  [OFTEN_SCREEN_IDS.MASTER_PRODUCT]: {
    name: 'common.common_product',
    link: 'master.product'
  },
  [OFTEN_SCREEN_IDS.MASTER_SUPPLIER]: {
    name: 'product.product_supplier',
    link: 'master.supplier'
  },
  [OFTEN_SCREEN_IDS.MASTER_CUSTOMER]: {
    name: 'sale.sale_customer',
    link: 'master.customer'
  },
  [OFTEN_SCREEN_IDS.MASTER_STORAGE]: {
    name: 'common.common_storage',
    link: 'master.storage'
  },
  [OFTEN_SCREEN_IDS.CSV_UPLOAD]: {
    name: 'common.common_csv-upload',
    link: 'csv.csvUpload'
  },
  [OFTEN_SCREEN_IDS.CSV_HISTORY]: {
    name: 'common.common_csv-history-view',
    link: 'csv.csvHistory'
  },
  [OFTEN_SCREEN_IDS.CSV_JD_PRODUCT]: {
    name: 'jd.jd_jdcom-product-master',
    link: 'csv.jdProduct'
  },
  [OFTEN_SCREEN_IDS.LEDGER_SHEET]: {
    name: 'common.common_form',
    link: 'ledgerSheet'
  }
}
